import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FAQSection from '@/components/feature/FAQSection';

const services = [
  {
    id: 'interior-design',
    icon: 'ri-palette-line',
    title: 'ინტერიერის დიზაინის კონსულტაცია',
    shortDesc: 'ექსპერტული დიზაინის კონსულტაცია კონცეფციიდან მასალების შერჩევამდე',
    fullDesc: 'ჩვენი ინტერიერის დიზაინის კონსულტაციის სერვისი გაწყვილებთ გამოცდილ დიზაინერებთან, რომლებიც ესმით როგორც ესთეტიკა, ასევე ფუნქციონალობა. ვეხმარებით პრემიუმ მასალების ვრცელ სამყაროში ნავიგაციაში — Laminam-ის დიდი ფორმატის კერამიკული ფილებიდან Antolini-ს ეგზოტიკური ბუნებრივი ქვამდე — სივრცეების შესაქმნელად, რომლებიც ლამაზია და გამძლეა.',
    features: [
      'პერსონალიზებული დიზაინის კონცეფციის შემუშავება',
      'მასალების შერჩევა და სპეციფიკაცია',
      'ფერთა პალიტრისა და ტექსტურის კოორდინაცია',
      '3D ვიზუალიზაცია და განწყობის დაფები',
      'ბიუჯეტის დაგეგმვა და ოპტიმიზაცია',
      'მომწოდებლის კოორდინაცია და შესყიდვა',
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20interior%20designer%20working%20with%20material%20samples%20and%20color%20swatches%20in%20a%20modern%20design%20studio%2C%20premium%20stone%20and%20tile%20samples%20on%20table%2C%20warm%20neutral%20tones%2C%20minimalist%20workspace%2C%20natural%20light%2C%20clean%20white%20and%20beige%20background&width=700&height=500&seq=svc1&orientation=landscape',
  },
  {
    id: 'materials-supply',
    icon: 'ri-building-2-line',
    title: 'სამშენებლო მასალების მიწოდება',
    shortDesc: 'პრემიუმ მასალები მსოფლიო წამყვანი ბრენდებიდან, მიწოდება თქვენს ობიექტზე',
    fullDesc: 'როგორც საქართველოში მსოფლიოს ყველაზე პრესტიჟული სამშენებლო მასალების ბრენდების ავტორიზებული დისტრიბუტორი, ვუზრუნველყოფთ პრემიუმ პროდუქტების შეუდარებელ სპექტრზე წვდომას. მაღალი ეფექტურობის ჰიდროიზოლაციის სისტემებიდან ულტრა-თხელ დიდი ფორმატის კერამიკულ ფილებამდე, ყველა პროდუქტი მოდის მწარმოებლის სრული გარანტიითა და ტექნიკური დოკუმენტაციით.',
    features: [
      'Laminam ულტრა-თხელი კერამიკული ფილები',
      'Antolini ექსკლუზიური ბუნებრივი ქვა',
      'Ardex მაღალი ეფექტურობის წებოები და სკრიდები',
      'Tecnopol ჰიდროიზოლაციის სისტემები',
      'Dicson პრემიუმ გარე ტექსტილი',
      'Fodbo ინოვაციური იატაკის გადაწყვეტილებები',
    ],
    image: 'https://readdy.ai/api/search-image?query=premium%20construction%20materials%20warehouse%20with%20large%20format%20stone%20slabs%20and%20tile%20samples%20organized%20on%20display%20racks%2C%20professional%20storage%20facility%2C%20warm%20neutral%20tones%2C%20clean%20industrial%20space%2C%20beige%20and%20gray%20background&width=700&height=500&seq=svc2&orientation=landscape',
  },
  {
    id: 'project-management',
    icon: 'ri-clipboard-line',
    title: 'პროექტის მართვა',
    shortDesc: 'სრული პროექტის კოორდინაცია უწყვეტი შესრულებისთვის',
    fullDesc: 'სამშენებლო ან სარემონტო პროექტის მართვა მოიცავს უამრავ კომპონენტს. ჩვენი პროექტის მართვის სერვისი ხსნის სირთულეებს — კოორდინაციას უწევს მასალების შესყიდვას, მიწოდების გრაფიკებს, მონტაჟის გუნდებსა და ხარისხის კონტროლს, რათა თქვენი პროექტი დასრულდეს დროულად და ბიუჯეტის ფარგლებში.',
    features: [
      'პროექტის ვადების დაგეგმვა და განრიგი',
      'მასალების შესყიდვა და ლოჯისტიკა',
      'კონტრაქტორებისა და მონტაჟის კოორდინაცია',
      'ხარისხის კონტროლი და ინსპექცია',
      'ბიუჯეტის მონიტორინგი და ანგარიშგება',
      'პროექტის დასრულების შემდგომი დოკუმენტაცია',
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20project%20manager%20reviewing%20construction%20plans%20and%20material%20specifications%20in%20a%20modern%20office%2C%20architectural%20drawings%20on%20desk%2C%20premium%20material%20samples%20nearby%2C%20warm%20neutral%20tones%2C%20clean%20minimalist%20workspace%2C%20natural%20light&width=700&height=500&seq=svc3&orientation=landscape',
  },
  {
    id: 'installation',
    icon: 'ri-tools-line',
    title: 'პროფესიული მონტაჟი',
    shortDesc: 'სერტიფიცირებული მონტაჟის გუნდები უნაკლო შედეგებისთვის',
    fullDesc: 'საუკეთესო მასალებიც კი ვერ გამოავლენს სრულ პოტენციალს, თუ სწორად არ დამონტაჟდება. ჩვენი სერტიფიცირებული მონტაჟის გუნდები გაწვრთნილია პირდაპირ ბრენდ-პარტნიორების მიერ, რაც უზრუნველყოფს ყველა პროდუქტის დამონტაჟებას მწარმოებლის სპეციფიკაციების შესაბამისად. ვმართავთ ყველაფერს ზედაპირის მომზადებიდან საბოლოო გამოსწორებამდე.',
    features: [
      'სერტიფიცირებული მონტაჟის სპეციალისტები',
      'ზედაპირის მომზადება და გრუნტი',
      'დიდი ფორმატის ფილებისა და ფილების მონტაჟი',
      'ბუნებრივი ქვის ჭრა და მოწყობა',
      'ჰიდროიზოლაციის სისტემის გამოყენება',
      'საბოლოო ინსპექცია და ჩაბარება',
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20tile%20installer%20carefully%20laying%20large%20format%20premium%20porcelain%20tiles%20in%20a%20luxury%20bathroom%2C%20precise%20craftsmanship%2C%20modern%20interior%20construction%2C%20warm%20neutral%20tones%2C%20clean%20professional%20work%20environment%2C%20beige%20and%20white%20background&width=700&height=500&seq=svc4&orientation=landscape',
  },
  {
    id: 'technical-support',
    icon: 'ri-customer-service-2-line',
    title: 'ტექნიკური მხარდაჭერა და ტრენინგი',
    shortDesc: 'ექსპერტული კონსულტაცია და პროფესიული ტრენინგი თქვენი გუნდისთვის',
    fullDesc: 'ჩვენი ტექნიკური მხარდაჭერის სერვისი უზრუნველყოფს, რომ ყოველთვის გქონდეთ ექსპერტულ ცოდნაზე წვდომა. იქნება ეს მასალების სპეციფიკაციებზე, მონტაჟის ტექნიკებზე თუ პრობლემების მოგვარებაზე — ჩვენი სპეციალისტების გუნდი მზადაა დაგეხმაროთ. ასევე ვთავაზობთ პროფესიულ ტრენინგ პროგრამებს კონტრაქტორებისა და მონტაჟის სპეციალისტებისთვის.',
    features: [
      'მასალების სპეციფიკაციის კონსულტაცია',
      'მონტაჟის ტექნიკის ტრენინგი',
      'ობიექტზე ტექნიკური დახმარება',
      'პრობლემების გამოვლენა და გადაჭრა',
      'გარანტიის მოთხოვნის მართვა',
      'მიმდინარე ტექნიკური მომსახურების კონსულტაცია',
    ],
    image: 'https://readdy.ai/api/search-image?query=construction%20materials%20technical%20expert%20providing%20training%20and%20consultation%20to%20a%20team%20of%20professionals%2C%20material%20samples%20and%20technical%20documents%20on%20table%2C%20modern%20training%20room%2C%20warm%20neutral%20tones%2C%20professional%20atmosphere%2C%20clean%20white%20background&width=700&height=500&seq=svc5&orientation=landscape',
  },
];

const servicesFaqs = [
  {
    question: 'როგორ შემიძლია Phoenix-ისგან მასალების შეკვეთა?',
    answer: 'მასალების შეკვეთა შეგიძლიათ რამდენიმე გზით: ეწვიეთ ჩვენს შოურუმს თბილისში (გელოვანის ქ. N13), დაგვიკავშირდით ტელეფონით (+995 599 87 20 20), ან შეავსეთ ონლაინ კონსულტაციის ფორმა. ჩვენი გუნდი განიხილავს თქვენს საჭიროებებს და მოამზადებს ინდივიდუალურ შეთავაზებას.',
  },
  {
    question: 'შეგიძლიათ თუ არა მასალების ნიმუშების მოწოდება?',
    answer: 'დიახ! ჩვენ ვთავაზობთ მასალების ნიმუშებს, რათა კლიენტებმა შეძლონ ფაქტობრივი ტექსტურის, ფერისა და ხარისხის შეფასება შეძენამდე. ნიმუშები ხელმისაწვდომია ჩვენს შოურუმში, ხოლო მსხვილი პროექტებისთვის შეგვიძლია ნიმუშები გამოვგზავნოთ.',
  },
  {
    question: 'გთავაზობთ თუ არა გარანტიას თქვენს პროდუქტებსა და სერვისებზე?',
    answer: 'ყველა ჩვენი პროდუქტი მოდის მწარმოებლის ოფიციალური გარანტიით. გარდა ამისა, ჩვენი მონტაჟის სერვისი მოიცავს სამუშაოს ხარისხის გარანტიას. კონკრეტული გარანტიის პირობები განსხვავდება პროდუქტისა და სერვისის მიხედვით — ჩვენი გუნდი მოგაწვდით სრულ ინფორმაციას.',
  },
  {
    question: 'მუშაობთ თუ არა მხოლოდ კომერციულ კლიენტებთან?',
    answer: 'არა, ვემსახურებით ყველა ტიპის კლიენტს — კერძო პირებიდან, რომლებიც ახდენენ სახლის რემონტს, დიდ სამშენებლო კომპანიებამდე. ჩვენი სერვისები ადაპტირებულია ნებისმიერი მასშტაბის პროექტისთვის.',
  },
  {
    question: 'შეგიძლიათ თუ არა პროექტის ბიუჯეტის შეფასება?',
    answer: 'დიახ, ვთავაზობთ უფასო საწყის კონსულტაციას, სადაც ჩვენი ექსპერტები განიხილავენ თქვენს პროექტს და მოამზადებენ სავარაუდო ბიუჯეტს. ეს გეხმარებათ სწორი გადაწყვეტილების მიღებაში ინვესტიციის განხორციელებამდე.',
  },
];

function ServiceCard({ service, index }: { service: typeof services[0]; index: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const isEven = index % 2 === 0;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center py-16 border-b border-gray-100 last:border-b-0"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.7s ease, transform 0.7s ease',
      }}
    >
      <div className={`${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
        <div className="w-full h-[320px] md:h-[380px] rounded-lg overflow-hidden">
          <img
            src={service.image}
            alt={`${service.title} - Phoenix Georgia`}
            className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>

      <div className={`${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
        <div className="w-10 h-10 flex items-center justify-center bg-brand-rust/10 rounded-lg mb-4">
          <i className={`${service.icon} text-brand-rust text-lg`}></i>
        </div>
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-brand-dark mb-3">{service.title}</h2>
        <p className="text-brand-rust text-sm font-medium mb-4">{service.shortDesc}</p>
        <p className="text-brand-gray text-sm leading-relaxed mb-6">{service.fullDesc}</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-6">
          {service.features.map((f) => (
            <li key={f} className="flex items-center gap-2 text-sm text-brand-charcoal">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-brand-rust text-xs"></i>
              </div>
              {f}
            </li>
          ))}
        </ul>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-brand-rust text-white font-semibold px-5 py-2.5 rounded-md hover:bg-[#b36a4b] transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap"
        >
          შეთავაზების მოთხოვნა <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}

export default function ServicesPage() {
  return (
    <div className="font-sans bg-white">
      <Navbar />

      {/* Page Hero */}
      <section className="relative h-[340px] md:h-[420px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20luxury%20construction%20project%20with%20premium%20materials%20being%20installed%2C%20professional%20workers%20in%20a%20high-end%20interior%20space%2C%20large%20format%20stone%20tiles%2C%20elegant%20architecture%2C%20warm%20neutral%20tones%2C%20sophisticated%20atmosphere%2C%20beige%20and%20cream%20background&width=1600&height=420&seq=svchero&orientation=landscape"
          alt="Phoenix Georgia სერვისები - პრემიუმ სამშენებლო მასალები"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        <div className="absolute inset-0 flex items-center justify-center flex-col text-center px-6">
          <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 bg-brand-rust/10 border border-brand-rust/30 px-3 py-1 rounded-full">
            რას ვაკეთებთ
          </span>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">ჩვენი სერვისები</h1>
          <p className="text-white/80 text-sm md:text-base max-w-xl leading-relaxed">
            სრული სამშენებლო მასალებისა და ინტერიერის დიზაინის სერვისები საცხოვრებელი და კომერციული პროექტებისთვის საქართველოში.
          </p>
          <div className="flex items-center gap-2 mt-4 text-white/60 text-xs">
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">სერვისები</span>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          {services.map((service, i) => (
            <ServiceCard key={service.id} service={service} index={i} />
          ))}
        </div>
      </section>

      {/* FAQ */}
      <FAQSection
        faqs={servicesFaqs}
        label="ხშირად დასმული კითხვები"
        title="სერვისებთან დაკავშირებული კითხვები"
        subtitle="ყველაფერი, რაც უნდა იცოდეთ ჩვენი სერვისების შესახებ. სხვა კითხვის შემთხვევაში, გთხოვთ დაგვიკავშირდეთ."
      />

      {/* CTA Banner */}
      <section className="bg-brand-dark py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">
            დაიწყეთ
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            მზად ხართ პროექტის განსახილველად?
          </h2>
          <p className="text-white/60 text-sm max-w-xl mx-auto mb-8 leading-relaxed">
            დაგვიკავშირდით დღეს უფასო კონსულტაციისთვის. ვიპოვით სრულყოფილ მასალებსა და სერვისებს თქვენი სამშენებლო ან სარემონტო პროექტისთვის.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-brand-rust text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#b36a4b] transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap"
            >
              უფასო კონსულტაციის მოთხოვნა
            </Link>
            <a
              href="tel:+995599872020"
              className="border border-white/30 text-white font-semibold px-7 py-3.5 rounded-md hover:bg-white/10 transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              +995 599 87 20 20
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
